import { render, staticRenderFns } from "./platformsandsolutions.vue?vue&type=template&id=98ad89c8"
import script from "./platformsandsolutions.vue?vue&type=script&lang=js"
export * from "./platformsandsolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports